import { startCase } from "lodash";

import type { SettingsFragment } from "../../common/graphql/fragments/gql/SettingsFragment";
import { trackEvent } from "../../common/tracking/trackerService";
import { FeatureFlag } from "../flags/enum";
import { getFeatureIsEnabled } from "../flags/featureFlags";
import type {
  SubscriptionKey,
  UserSubscription,
} from "./userSubscriptionsReducer";

type SubscriptionChannel = "Sms" | "Email" | "FreightPortal";

const trackSubscription = (
  subscription: SubscriptionKey,
  channel: SubscriptionChannel,
  added: boolean,
) => {
  const subscriptionName = startCase(subscription);
  trackEvent(
    {
      category: "Subscriptions",
      action: added ? "Add Subscription" : "Remove Subscription",
      label: subscriptionName + " " + channel,
    },
    { subscription_name: subscriptionName, subscription_type: channel },
  );
};

export const trackChangedUserSubscriptions = (
  prevState: Record<SubscriptionKey, UserSubscription>,
  newState: Record<SubscriptionKey, UserSubscription>,
) => {
  (Object.keys(newState) as SubscriptionKey[]).forEach((key) => {
    const prevSubscription = prevState[key];
    const newSubscription = newState[key];
    if (newSubscription.smsEnabled !== prevSubscription.smsEnabled) {
      trackSubscription(key, "Sms", newSubscription.smsEnabled);
    }
    if (newSubscription.emailEnabled !== prevSubscription.emailEnabled) {
      trackSubscription(key, "Email", newSubscription.emailEnabled);
    }
    if (
      newSubscription.freightPortalEnabled !==
      prevSubscription.freightPortalEnabled
    ) {
      trackSubscription(
        key,
        "FreightPortal",
        newSubscription.freightPortalEnabled,
      );
    }
  });
};

export const getIsUserMigrated = (settings: SettingsFragment) =>
  settings.accountLoginEmail?.toLowerCase() ===
    settings.accountEmail?.toLowerCase() && !settings.accountSecondEmail;

export const shouldShowNewSubscriptions = (settings: SettingsFragment) =>
  getIsUserMigrated(settings) &&
  getFeatureIsEnabled(FeatureFlag.UserSubscriptions);
